import React, { useState } from "react";
import styled from "styled-components";
import Modal from "./Modal.tsx";
import {
  ModalButtonRow,
  CancelButton,
  DangerButton,
  SmallText,
  ErrorMessage,
} from "./ModalFormComponents.tsx";
import { deleteCustomCategory } from "../services/categories.service.ts";
import { parseApiError } from "../utils/errorHandler.ts";

const CategoryName = styled.span`
  font-weight: 600;
  color: #001f52;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #e0e0e0;
  }
`;

interface DeleteCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  categoryId: number;
  categoryName: string;
  onSuccess?: () => void;
}

export default function DeleteCategoryModal({
  isOpen,
  onClose,
  categoryId,
  categoryName,
  onSuccess,
}: DeleteCategoryModalProps) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    if (deleting) return;
    setError(null);
    onClose();
  };

  const handleDelete = async () => {
    setError(null);
    setDeleting(true);
    try {
      await deleteCustomCategory(categoryId);
      onSuccess?.();
      setDeleting(false);
      onClose();
    } catch (err: unknown) {
      setError(parseApiError(err));
      setDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Slet kategori">
      <SmallText>
        Er du sikker på, at du vil slette kategorien{" "}
        <CategoryName>{categoryName}</CategoryName>?
      </SmallText>
      <SmallText>
        Alle mapper og dokumenter i kategorien slettes også.
      </SmallText>
      <SmallText>Denne handling kan ikke fortrydes.</SmallText>
      {error && <ErrorMessage>{error}</ErrorMessage>}

      <ModalButtonRow>
        <CancelButton onClick={handleClose} disabled={deleting}>
          Annuller
        </CancelButton>
        <DangerButton onClick={handleDelete} disabled={deleting}>
          {deleting ? "Sletter..." : "Slet"}
        </DangerButton>
      </ModalButtonRow>
    </Modal>
  );
}
